/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TrimesterObservation from './trimester-observation';
import TrimesterObservationDetail from './trimester-observation-detail';
import TrimesterObservationUpdate from './trimester-observation-update';
import TrimesterObservationDeleteDialog from './trimester-observation-delete-dialog';

const TrimesterObservationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TrimesterObservation />} />
    <Route path="new" element={<TrimesterObservationUpdate />} />
    <Route path=":id">
      <Route index element={<TrimesterObservationDetail />} />
      <Route path="edit" element={<TrimesterObservationUpdate />} />
      <Route path="delete" element={<TrimesterObservationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TrimesterObservationRoutes;
